import { setSpeechAuth } from '../speech.ts';
import { ApiStore } from './api.ts';
import { LocalStore } from './local.ts';
import type { LearnerStore } from './types.ts';

/**
 * Which backend the build talks to, chosen at build time:
 *   VITE_STORE=api    Worker + D1 behind Better Auth (production)
 *   VITE_STORE=local  localStorage prototype (dev, preview, Playwright)
 * Unset: local.
 */
const mode = (import.meta.env.VITE_STORE as string | undefined) || 'local';

function pick(): LearnerStore {
  if (mode === 'api') return new ApiStore();
  return new LocalStore();
}

export const store: LearnerStore = pick();

// Let the speech assessment call the Worker as the signed-in parent: the session cookie in api
// mode, nothing in local mode.
if (store.kind === 'api') {
  setSpeechAuth({ mode: 'cookie' });
}
export * from './types.ts';
